import Nullstack from 'nullstack';
export default function IconEaseOutControlPoint({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ease-out-control-point",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21s10 -16 18 -16"
  }), "   ", Nullstack.element("path", {
    d: "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M7 5h2"
  }), "   ", Nullstack.element("path", {
    d: "M14 5h-2"
  }), " ");
}